import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styled from 'styled-components';

import { colors } from '../../../core';

export interface ScrollingPanelProps {
  children: React.ReactNode;
}

const ScrollContainer = styled(Scrollbars)`
  height: 100%;
  width: 100%;
`;

const ScrollThumb = styled.div`
  background-color: ${colors.smoke};
  border-radius: 6px;
`;

const ScrollingPanel = ({ children, ...rest }: ScrollingPanelProps) => (
  <ScrollContainer
    {...rest}
    renderThumbHorizontal={(props: any) => <ScrollThumb {...props} />}
    renderThumbVertical={(props: any) => <ScrollThumb {...props} />}
  >
    {children}
  </ScrollContainer>
);

export default ScrollingPanel;
